import {
  Create,
  Box,
  TextField,
  FormLabel,
  FormHelperText,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  bot_id: Yup.number().required(),
  check_affiliate: Yup.boolean().required(),
  exchange: Yup.string().trim().required(),
});

interface formDataType {
  bot_id: number;
  check_affiliate: boolean;
  exchange: string;
}

export const BotExchangeCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("bot_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.bot_id}
          helperText={(errors as any)?.bot_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Bot Id"
          name="bot_id"
        />
        <Controller
          control={control}
          name="check_affiliate"
          render={({ field: { onChange, value } }) => (
            <FormControl required error={!!(errors as any)?.check_affiliate}>
              <FormLabel>Check Affiliate</FormLabel>
              <RadioGroup
                row
                onChange={(_, value) => onChange(value === "true")}
                value={value}
              >
                <FormControlLabel
                  control={<Radio />}
                  label="True"
                  value={true}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="False"
                  value={false}
                />
              </RadioGroup>
              <FormHelperText>
                {(errors as any)?.check_affiliate?.message}
              </FormHelperText>
            </FormControl>
          )}
        />
        <TextField
          {...register("exchange", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.exchange}
          helperText={(errors as any)?.exchange?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Exchange"
          name="exchange"
        />
      </Box>
    </Create>
  );
};
